import type { MeWorkspace } from '@/api/services/me';

export function workspaceIcon(
  item: Partial<Pick<MeWorkspace, 'workspaceType' | 'scope'>>,
): string {
  if (item.scope === 'personal' || item.workspaceType === 'personal') return '🏠';
  return '🏢';
}
